import {
  getPersonnelsByReferenceNumberEndpoint,
  getPersonnelsEndpoint,
  http,
  Personnels,
  PersonnelsByReferenceNumberPayload,
  PersonnelsPayload,
  PersonnelsResponseSchema,
} from "@/services";
import { AxiosRequestConfig } from "axios";

export const requestPersonnels = (
  { email, agreementNumber, supplierId }: PersonnelsPayload,
  config?: AxiosRequestConfig,
  isFlatResponse?: boolean,
) =>
  http.get<Personnels>(
    getPersonnelsEndpoint,
    { email, agreementNumber, supplierId },
    config,
    undefined,
    PersonnelsResponseSchema,
    isFlatResponse,
  );

export const requestPersonnelsByReferenceNumber = (
  {
    email,
    referenceNumber,
    isSelected,
    isDraft,
  }: PersonnelsByReferenceNumberPayload,
  config?: AxiosRequestConfig,
  isFlatResponse?: boolean,
) =>
  http.get<Personnels>(
    getPersonnelsByReferenceNumberEndpoint,
    { email, referenceNumber, isSelected, isDraft },
    config,
    undefined,
    PersonnelsResponseSchema,
    isFlatResponse,
  );
